module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("国际化")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("暂时只支持配合"), _c('code', [_vm._v("vux-loader")]), _vm._v("使用。")]), _vm._v(" "), _c('p', [_vm._v("如果你只需要默认的中文组件，那么你可以略过下面说明，只要启用"), _c('code', [_vm._v("vux-ui")]), _vm._v("插件即可。")])]), _vm._v(" "), _c('p', [_vm._v("默认不配置此插件时，vux源码会按照默认语言"), _c('code', [_vm._v("zh-CN")]), _vm._v("进行静态编译，和原来的使用没有明显不同。")]), _vm._v(" "), _c('p', [_vm._v("详细请参照 "), _c('a', {
    staticStyle: {
      "color": "#42b983"
    },
    attrs: {
      "router-link": "/zh-CN/vux-loader?id=i18n"
    }
  }, [_vm._v("vux-loader的vux-i18n文档")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c76c2826", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-c76c2826"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/i18n-279.vue
// module id = 2443
// module chunks = 434